import { GHAT_IMAGES } from '../constants/ghats';

export const ghatRoutes = [
  {
    path: 'guptar-ghat',
    name: 'Guptar Ghat',
    description: 'A religious place located on the western bank of the Ghaghra River, also known as Saryu River, in Ayodhya district of Uttar Pradesh.',
    image: GHAT_IMAGES.GUPTAR_GHAT.THUMBNAIL,
    gallery: GHAT_IMAGES.GUPTAR_GHAT.GALLERY,
    timings: 'Open 24 hours',
    significance: 'Guptar Ghat is a religious place located on the western bank of the Ghaghra River. The birth place of Lord Rama and the area around him is known as Ayodhya, especially Saket. The glory of Guptar Ghat has been described in the scriptures. Guptar ghat is about 9 kilometers from Hanumangarhi in Ayodhya. Guptar Ghat looks different from other ghats of Shri Ayodhya-ji in many ways. There is neither the presence of pandits nor a religious environment in the true sense. Solitude on the ghat does not give a feeling of indifference, rather it provides conscious peace. According to Hindu mythology, Lord Ram took Jal Samadhi at Guptar Ghat and went to Baikunth Dham. Baikuntha Dham is the name of the abode of Lord Shri ram Vishnu. The view of the mythology makes the Saryu River sacred for the believers of Hindu religion and the devotees of Lord Ram. Since Guptar Ghat is related to Lord Ram, the place also has its own cultural significance.',
    tags: ['Religious', 'Historical', 'River Bank'],
    coordinates: [26.7922, 82.1998]
  },
  {
    path: 'saryu-ghat',
    name: 'Saryu Ghat',
    description: 'This is the place where the stone stairs are taken to the river Saryu. This Ghat is considered very sacred in Hindus.',
    image: GHAT_IMAGES.SARYU_GHAT.THUMBNAIL,
    gallery: GHAT_IMAGES.SARYU_GHAT.GALLERY,
    timings: 'Open 24 hours',
    significance: 'This Ghat is considered very sacred in Hindus, because this Ghat has the belief that Lord Rama had taken the water to this place to leave the earth and entered the holy house of Lord Vishnu or Vaikuntha.',
    tags: ['Religious', 'Sacred', 'River Bank'],
    coordinates: [26.7984, 82.1997]
  },
  {
    path: 'naya-ghat',
    name: 'Naya Ghat (Ram ki Paidi)',
    description: 'Naya Ghat (Ram ki Paidi)',
    image: GHAT_IMAGES.NAYA_GHAT.THUMBNAIL,
    gallery: GHAT_IMAGES.NAYA_GHAT.GALLERY,
    timings: 'Open 24 hours',
    significance: 'This is a newly constructed ghat with beautiful steps leading to the Saryu river. It is a popular spot for tourists and devotees to take a holy dip in the sacred waters.',
    tags: ['Religious', 'Modern', 'River Bank'],
    coordinates: [26.7956, 82.1947]
  },
  {
    path: 'lakshman-ghat',
    name: 'Lakshman Ghat',
    description: 'The ghat is on the banks of the Sarayu River. This is where Rama\'s brother Lakshman is said to have...',
    image: GHAT_IMAGES.LAKSHMAN_GHAT.THUMBNAIL,
    gallery: GHAT_IMAGES.LAKSHMAN_GHAT.GALLERY,
    timings: 'Open 24 hours',
    significance: 'Lakshman Ghat is named after Lord Ram\'s devoted brother Lakshman. According to legends, this is where Lakshman took his last bath in the Saryu river before leaving his mortal body.',
    tags: ['Religious', 'Historical', 'River Bank'],
    coordinates: [26.7940, 82.1980]
  },
  {
    path: 'kaushalya-ghat',
    name: 'Kaushalya Ghat',
    description: 'Kaushalya Ghat is a hidden gem located 100 meters away on the Parikrama route from Brahm Kund Ghat.',
    image: GHAT_IMAGES.KAUSHALYA_GHAT.THUMBNAIL,
    gallery: GHAT_IMAGES.KAUSHALYA_GHAT.GALLERY,
    timings: 'Open 24 hours',
    significance: 'Named after Queen Kaushalya, the mother of Lord Ram, this ghat holds special significance for devotees who believe that she used to take her bath here in the Saryu river.',
    tags: ['Religious', 'Historical', 'River Bank'],
    coordinates: [26.7930, 82.1970]
  },
  {
    path: 'jhunki-ghat',
    name: 'Jhunki Ghat',
    description: 'Jhunki Ghat named after a saint, who is said to be a devout worshiper of God, or Bahuet Dhara that...',
    image: GHAT_IMAGES.JHUNKI_GHAT.THUMBNAIL,
    gallery: GHAT_IMAGES.JHUNKI_GHAT.GALLERY,
    timings: 'Open 24 hours',
    significance: 'Jhunki Ghat is named after a saint who was a devout worshiper. It is a peaceful spot along the Saryu river where pilgrims come to meditate and offer prayers.',
    tags: ['Religious', 'Peaceful', 'River Bank'],
    coordinates: [26.7935, 82.1975]
  },
  {
    path: 'tulsi-ghat',
    name: 'Tulsi Ghat',
    description: 'This ghat is also famous for its beautiful temple dedicated to Lord Ram, which is believed to have been...',
    image: GHAT_IMAGES.TULSI_GHAT.THUMBNAIL,
    gallery: GHAT_IMAGES.TULSI_GHAT.GALLERY,
    timings: 'Open 24 hours',
    significance: 'Tulsi Ghat is named after the famous poet-saint Tulsidas, who composed the Ramcharitmanas. This ghat is believed to be the place where he used to sit and compose his verses in praise of Lord Ram.',
    tags: ['Religious', 'Literary', 'River Bank'],
    coordinates: [26.7925, 82.1965]
  },
  {
    path: 'gau-ghat',
    name: 'Gau Ghat',
    description: 'Gau Ghat is a hidden gem located 100 meters away on the Parikrama route from Brahm Kund Ghat.',
    image: GHAT_IMAGES.GAU_GHAT.THUMBNAIL,
    gallery: GHAT_IMAGES.GAU_GHAT.GALLERY,
    timings: 'Open 24 hours',
    significance: 'Gau Ghat is named after a cow, which is said to be a devout worshiper of God, or Bahuet Dhara that...',
    tags: ['Religious', 'Historical', 'River Bank'],
    coordinates: [26.7925, 82.1965]
  }
];
